import { Component, inject } from '@angular/core';
import { BurgerMenuComponent } from "./burger-menu/burger-menu.component";
import { HeaderAccountInfoComponent } from "./header-account-info/header-account-info.component";
import { HelpComponent } from "./help/help.component";
import { ImpersonateComponent } from "./impersonate/impersonate.component";
import { NgOptimizedImage } from "@angular/common";
import {
	NotificationsComponent
} from "./notifications/notifications.component";
import { RightMenuComponent } from "./right-menu/right-menu.component";
import { RouterLink } from "@angular/router";
import { menuPermissions, Session, organizationInfo } from "../../../services/session.service";
import { ConnectionService } from "../../../services/connection.service";

@Component({
  selector: 'app-header',
	imports: [
		BurgerMenuComponent,
		HeaderAccountInfoComponent,
		HelpComponent,
		ImpersonateComponent,
		NgOptimizedImage,
		NotificationsComponent,
		RightMenuComponent,
		RouterLink
	],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  public currentUser;
  public organizationInfo:organizationInfo;
  public canShowMenu: menuPermissions;
  public online = true;
  isEvaluatorActingForAccreditor: boolean = false;
  isFaculty: boolean = false;

  private readonly session:Session = inject(Session);
  private readonly connectionService:ConnectionService = inject(ConnectionService);

  ngOnInit() {
    this.isEvaluatorActingForAccreditor = this.session.isEvaluatorWorkingForOtherInstitution();
    this.isFaculty = this.session.isFaculty();
    this.currentUser = this.session.getUser();
    this.canShowMenu = this.session.getPermissionToShow;
    this.session.getOrganizationInfo()
      .then((organizationInfo) => {
        this.organizationInfo = organizationInfo;
      });
    this.observeConnectionLost();
  }

  observeConnectionLost(){
    this.connectionService.offlineStatus.subscribe(() =>{
      this.online = false;
    });
    this.connectionService.onlineStatus.subscribe(() =>{
      this.online = true;
    })
  }

  showNoInternetModal(){
    this.connectionService.showNoInternetWarning();
  }
}
